import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import classNames from 'classnames';
import _ from 'lodash';
import dayjs from 'dayjs';

import {
  CustomButton,
  CustomDatePicker,
  CustomInput,
  CustomPagination,
  CustomSelect,
  CustomTable,
  WhiteCard,
} from 'src/components';

// import { ReactComponent as SettingsIcon } from 'src/assets/overall/SettingsIcon.svg';
import { ReactComponent as AddIcon } from 'src/assets/overall/AddIcon.svg';
import './adminBuilder.scss';

const typeToComponent = {
  input: CustomInput,
  datepicker: CustomDatePicker,
  select: CustomSelect,
};

export const AdminBuilder = ({ build }) => {
  const {
    title,
    table_data,
    table_columns,
    table_meta = {},
    is_visible_add = true,
    main_route,
    filters,
    filters_data = {},
    on_submit_filters = () => {},
    set_filters_data = () => {},
    styled_by_status = false,
    // tabs,
    // api,
  } = build;

  const {
    current_page,
    per_page,
    total_items,
    // total_pages,
    on_change_page = () => {},
  } = table_meta;

  const { t } = useTranslation();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  // const [isExpanded, setIsExpanded] = useState(false);

  const onChange = useCallback(
    (key) => (event, string) => {
      if (!_.isArray(event)) {
        if (event.target) {
          return set_filters_data((prev) => ({ ...prev, [key]: event.target.value }));
        }

        set_filters_data((prev) => ({ ...prev, [key]: event?.value }));
      }

      if (_.isArray(event)) {
        const from = event?.[0] || '';
        const to = event?.[1] || '';

        set_filters_data((prev) => ({ ...prev, from, to }));
      }
    },
    [set_filters_data],
  );

  // const onClickManage = useCallback(() => {
  //   setIsExpanded((prev) => !prev);
  // }, []);

  const onClickAdd = useCallback(() => {
    navigate(`${main_route}/create`);
  }, [navigate, main_route]);

  const convertedSearchParams = Object.fromEntries(searchParams.entries());

  const onCLickApply = useCallback(
    (event) => {
      event.preventDefault();

      const data = { ...convertedSearchParams, ...filters_data, page: 1 };

      for (const key in data) {
        if (!data[key]) {
          delete data[key];
        }
      }

      setSearchParams(data);

      on_submit_filters(data);
    },
    [convertedSearchParams, setSearchParams, on_submit_filters, filters_data],
  );

  // const menuStyles = classNames('custom-select__menu', {
  //   'custom-select__menu--active': isExpanded,
  //   'custom-select__menu--inactive': !isExpanded,
  // });

  // const buttonStyles = classNames('admin-builder__button', {
  //   'admin-builder__button--active': isExpanded,
  //   'admin-builder__button--inactive': !isExpanded,
  // });

  return (
    <div className="admin-builder">
      <div className="admin-builder__content">
        <WhiteCard>
          <div className="admin-builder__header">
            <h2>{title}</h2>
            <div className="admin-builder__settings">
              {/* <div className="admin-builder__settings__button">
                <CustomButton
                  className={buttonStyles}
                  title={t('title:manage')}
                  icon={<SettingsIcon />}
                  onClick={onClickManage}
                />
                <div className={menuStyles}>
                  <div className="admin-builder__settings__item">
                    <CustomButton title={t('title:manage')} icon={<SettingsIcon />} />
                  </div>
                  <div className="admin-builder__settings__item">
                    <CustomButton title={t('title:manage')} icon={<SettingsIcon />} />
                  </div>
                  <div className="admin-builder__settings__item">
                    <CustomButton title={t('title:manage')} icon={<SettingsIcon />} />
                  </div>
                </div>
              </div> */}
              {is_visible_add && (
                <div className="admin-builder__settings__button">
                  <CustomButton
                    title={t('title:add')}
                    icon={<AddIcon />}
                    color="green"
                    onClick={onClickAdd}
                  />
                </div>
              )}
            </div>
          </div>

          <CustomTable
            build={build}
            data={table_data}
            columns={table_columns}
            styledByStatus={styled_by_status}
            withCheckbox={false}
          />
          <CustomPagination
            totalItems={total_items}
            initialPage={current_page}
            initialPerPage={per_page}
            withSelect={false}
            onPageChange={on_change_page}
          />
        </WhiteCard>
      </div>
      {filters?.length ? (
        <div className="admin-builder__filters">
          <WhiteCard>
            <form onSubmit={onCLickApply}>
              {filters.map((item, index) => {
                const Component = typeToComponent[item.type];

                const value =
                  item.type !== 'datepicker'
                    ? filters_data?.[item.key]
                    : [
                        filters_data?.from ? dayjs(filters_data?.from) : null,
                        filters_data?.to ? dayjs(filters_data?.to) : null,
                      ];

                return (
                  <Component
                    key={index}
                    value={value}
                    label={item.label}
                    options={
                      item.options ? [{ label: 'Все', value: '' }, ...item.options] : item.options
                    }
                    onChange={onChange(item.key)}
                  />
                );
              })}
              {filters?.length ? <CustomButton title={t('title:apply')} color="green" /> : null}
            </form>
          </WhiteCard>
        </div>
      ) : null}
    </div>
  );
};
